// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"style_toolbar_1BSfy","toolbarButton":"style_toolbarButton_2O2XJ"};